import React from 'react'
import {
  ServerOption,
  defaultServers,
  harryPotterServers,
  lifeAfterServers,
  nikkeServers,
  onceHumanServers,
} from '@entities/server'
import { TextField, OldSelectField } from '@shared/ui/organisms'
import MobileLabelWithTooltip from '../ui/MobileLabelWithTooltip'
import { GenshinTooltipMobile } from '../ui/GenshinTooltipMobile'
import { PubgTooltipMobile } from '../ui/PubgTooltipMobile'
import { GenshinTooltip } from '../ui/GenshinTooltip'
import { PubgTooltip } from '../ui/PubgTooltip'

type GetServerOptionsType = (serviceName: string) => ServerOption[]

export const getServerOptions: GetServerOptionsType = (serviceName: string) => {
  switch (serviceName) {
    case 'goddess-of-victory-nikke':
      return nikkeServers
    case 'harry-potter-magic-awakened':
      return harryPotterServers
    case 'lifeafter':
      return lifeAfterServers
    case 'once-human':
      return onceHumanServers
    default:
      return defaultServers
  }
}

export const TYPE_OF_FIELDS_TO_BE_MAPPED = [
  'id1',
  'region',
  'zone',
  // новые
  'email',
  'uid',
  'uidPubg',
  'server',
  'id',
  'zoneId',
  'playerId',
]

export const IS_CLEARABLE_BY_NAME = {
  id1: true,
  region: false,
  zone: true,
  // новые
  email: true,
  uid: true,
  server: false,
  uidPubg: true,
  id: true,
  zoneId: true,
  playerId: true,
}

export const COMPONENTS_BY_NAME = {
  id1: TextField,
  region: TextField,
  zone: TextField,
  // новые
  email: TextField,
  uid: TextField,
  server: OldSelectField,
  uidPubg: TextField,
  id: TextField,
  zoneId: TextField,
  playerId: TextField,
}

export const MASK_BY_SERVICE_AND_NAME = {
  'mobile-legends-bang-bang': {
    id: new Array(50).fill(/\d/),
    zoneId: new Array(50).fill(/\d/),
  },
}

export const MOBILE_LABEL_BY_SERVICE_AND_NAME = {
  genshin: {
    uid: (
      <MobileLabelWithTooltip
        onClick={({ handleSwitchTooltipIsOpen }) => handleSwitchTooltipIsOpen()}
        tooltip={({ isTooltipOpen, handleSwitchTooltipIsOpen }) => (
          <GenshinTooltipMobile open={isTooltipOpen} handleClose={handleSwitchTooltipIsOpen} />
        )}
      />
    ),
  },
  'pubg-mobile': {
    uidPubg: (
      <MobileLabelWithTooltip
        onClick={({ handleSwitchTooltipIsOpen }) => handleSwitchTooltipIsOpen()}
        tooltip={({ isTooltipOpen, handleSwitchTooltipIsOpen }) => (
          <PubgTooltipMobile open={isTooltipOpen} handleClose={handleSwitchTooltipIsOpen} />
        )}
      />
    ),
  },
}

export const DESKTOP_TOOLTIP_BY_SERVICE_AND_NAME = {
  genshin: {
    uid: <GenshinTooltip />,
  },
  'pubg-mobile': {
    uidPubg: <PubgTooltip />,
  },
}
